import { render, staticRenderFns } from "./ContentTree.vue?vue&type=template&id=2a4a5d80&scoped=true&"
import script from "./ContentTree.vue?vue&type=script&lang=ts&"
export * from "./ContentTree.vue?vue&type=script&lang=ts&"
import style0 from "./ContentTree.vue?vue&type=style&index=0&id=2a4a5d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a5d80",
  null
  
)

export default component.exports